import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
} from "@material-ui/core";
import useNotesContext from "../../../hooks/useNotesContext";
import { PinIcon } from "../PinIcon/PinIcon";

const MAX_LENGTH = 500;

const AddNoteForm = ({ onCancel }) => {
  const { addNote } = useNotesContext();
  const [content, setContent] = useState("");
  const [pinned, setPinned] = useState(false);

  const trimmed = content.trim();
  const isSubmitDisabled = trimmed.length === 0;

  const handleSubmit = async () => {
    if (isSubmitDisabled) return;
    await addNote(trimmed, pinned);
    setContent("");
    setPinned(false);
    onCancel();
  };

  return (
    <Box display="flex" flexDirection="column">
      <TextField
        multiline
        fullWidth
        minRows={3}
        variant="outlined"
        placeholder="Enter note..."
        value={content}
        onChange={(e) => setContent(e.target.value.slice(0, MAX_LENGTH))}
        inputProps={{ maxLength: MAX_LENGTH, className: "add-note-input" }}
      />
      <Typography variant="caption" align="right" className="add-note-char-counter">
        {content.length}/{MAX_LENGTH}
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
        <Box display="flex" alignItems="center">
          <IconButton
            size="small"
            color={pinned ? "primary" : "default"}
            onClick={() => setPinned((prev) => !prev)}
            className="pin-toggle"
          >
            <PinIcon pinned={pinned} />
          </IconButton>
          <Typography
            variant="body2"
            color={pinned ? "primary" : "textSecondary"}
            style={{ cursor: "pointer" }}
            onClick={() => setPinned((prev) => !prev)}
          >
            {pinned ? "Pinned" : "Pin note"}
          </Typography>
        </Box>
        <Box display="flex">
          <Box mr={1}>
            <Button onClick={onCancel} variant="contained" className="cancel-note-button">
              Cancel
            </Button>
          </Box>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={isSubmitDisabled}
            className="save-note-button"
          >
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddNoteForm;
